<template>
    <div class="MAM_queryList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="queryForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="queryForm.up_code" placeholder="请输入方案编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.title" placeholder="请输入方案名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.merchant_number" placeholder="请输入商户编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.merchant_name" placeholder="请输入商户名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="queryForm.brand_id" clearable placeholder="请选择关联政策">
                        <el-option
                            v-for="item in brandList"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.terminal_sn" placeholder="请输入SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.phone" placeholder="请输入直属代理商账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.p1_phone" placeholder="请输入所属代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="queryForm.effective_status" clearable placeholder="请选择调价状态">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="待生效" :value="0"></el-option>
                        <el-option label="已生效" :value="1"></el-option>
                        <el-option label="已失效" :value="2"></el-option>
                        <el-option label="调价失败" :value="3"></el-option>
                        <el-option label="上送失败" :value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                        <el-date-picker
                            v-model="rangeDate2"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="调价开始日期"
                            end-placeholder="调价结束日期"
                            value-format="yyyy-MM-dd"
                            @change="pickerChange2"
                        ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"  @click="onSearch(queryForm)">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                      size="small"
                      type="primary"
                      icon="el-icon-download"
                      :loading="downLoading"
                      @click="handleDownLoad(queryForm)"
                  >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">

            <el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <el-table-column  width="160px"  header-align="center" align="center" prop="up_code" label="涨价方案编号"></el-table-column>
                <el-table-column  width="150px"  header-align="center" align="center" prop="title" label="方案名称"></el-table-column>
                <el-table-column  width="150px"  header-align="center" align="center" prop="channel_from_text" label="进件渠道"></el-table-column>
                <el-table-column  width="150px"  header-align="center" align="center" prop="merchant_number" label="商户编号"></el-table-column>
                <el-table-column width="150px" header-align="center" align="center" prop="merchant_name" label="商户名称"></el-table-column>
                <el-table-column width="150px" header-align="center" align="center" prop="terminal_sn" label="终端SN"></el-table-column>
                 <el-table-column width="150px" header-align="center" align="center" prop="brand_name" label="关联政策"></el-table-column>
                 <el-table-column width="150px" header-align="center" align="center" prop="nickname" label="直属代理商昵称"></el-table-column>
                 <el-table-column width="150px" header-align="center" align="center" prop="phone" label="直属代理商账号"></el-table-column> 
                  <el-table-column  width="150px" header-align="center" align="center" prop="p1_nickname" label="所属机构昵称"></el-table-column>
                  <el-table-column  width="150px" header-align="center" align="center" prop="p1_phone" label="所属机构账号"></el-table-column>
                  <el-table-column width="150px" header-align="center" align="center" prop="rate_up_text" label="调价方式"></el-table-column>
                  <el-table-column width="150px" header-align="center" align="center" prop="base_rate" label="费率基准价(%)"></el-table-column>
                  <el-table-column width="150px" header-align="center" align="center" prop="terminal_base_rate" label="原始费率(%)"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="up_terminal_rate" label="调整费率值(%)"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="effective_rate_status_text" label="调价状态">
                       <template slot-scope="scope">
                       	  <span v-if="scope.row.effective_rate_status == 0">{{scope.row.effective_rate_status_text}}</span>
                           <span v-else-if="scope.row.effective_rate_status == 1" style="color: #81B437;">{{scope.row.effective_rate_status_text}}</span>
                           <span v-else style="color: #f00;">{{scope.row.effective_rate_status_text}}</span>
                      </template>
                   </el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="remark" label="备注"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="effective_rate_time" label="调价时间"></el-table-column>     
            </el-table>
            <!-- 分页部分 -->
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            	:page-sizes="[10,20,50,100]" :current-page="page.currentPage" :page-size="page.pageSize" :total="page.total"
            	layout="total, sizes, prev, pager, next, jumper" style="text-align: center"></el-pagination>
        </el-card>

    </div>
</template>

<script>
    export default {
        name: "rateAdjustmentRecord",
        data() {
            return {
                queryForm: {
                    terminal_sn:'', // sn
                    up_code:'',  // 方案编号
                    title:'',
                    nickname:'',
                    merchant_name:'',
                    merchant_number:'',
                    brand_id:'',
                    phone:'',
                    p1_phone:'',
                    type:1,
                    effective_start_time:'',
                    effective_end_time:'',
                    effective_status:''
                },
                stockTable: { //列表
                    list: []
                },
                page: {
                    currentPage: 1, //当前页码
                    pageSize: 10, //条数
                    total: 0, //总数
                },
                loading: true,
                downLoading: false, //导出loading
                brandList:[],
                level: sessionStorage.getItem('level'),
                rangeDate2:[]
                
            }
        },
        mounted() {
            this.page.currentPage = 1;
            this.queryForm.page = this.page.currentPage;
            this.queryForm.limit = this.page.pageSize;
            this.getData(this.queryForm)
            this.getBrandData()
        },
        methods: {
            pickerChange2(DateArr) { //时间选择器
                this.queryForm.effective_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.queryForm.effective_end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            },
            getBrandData() { // 初始化数据
                this.$api.post('brand/brand_list', {}, res => {
                    if (res.code == 0) {
                        this.brandList = res.data.list;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
                
            },
            handleDownLoad(searchForm) { //导出
            	let reqData = {
            		type: 30,
            		value: JSON.stringify(searchForm)
            	};
            	
            	this.downLoading = true; 
            	this.$api.post('export/add', reqData, res => {
            		if (res.code == 0) {
            			this.$message.success(res.msg);
            			this.downLoading = false;
            		} else {
            			this.$message.error(res.msg);
            			this.downLoading = false;
            		}
            	
                })
            },
            onSearch(queryForm) {
                this.page.currentPage = 1;
                queryForm.page = this.page.currentPage;
                queryForm.limit = this.page.pageSize;
                // 表单提交
                this.getData(queryForm);
            },
            //分页
            handleCurrentChange(page) {
                // 获取当前页修改的值
                this.page.currentPage = page;
                this.loading = true;
                this.queryForm.page = page;
                this.queryForm.limit = this.page.pageSize;
                this.getData(this.queryForm);
            },
            handleSizeChange(limit) {
                this.page.currentPage = 1;
                // 获取条数发生改变的值
                this.page.pageSize = limit;
                this.loading = true;
                this.queryForm.page = this.page.currentPage;
                this.queryForm.limit = limit;
                this.getData(this.queryForm);
            },
            getData(params) {
                this.$api.post("platform_rate_up/platformRateUpList", params, res => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.page.total = data.count; //总数
                        this.stockTable.list = data.list;
                    } else {
                        this.$message.error(res.msg);
                    }
                    // //渲染结束后取消加载
                    this.loading = false;
                })
            }
        }
    };
</script>

<style lang="scss" scope>
    .MAM_queryList {
        .el-input__inner {
            font-size: 12px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }
    }

    .header>.el-card__body {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .headerDivd {
        padding-right: 50px;
        font-size: 14px;
        color: #E6A23C;
    }

    .headerMoney {
        font-size: 28px;
        font-weight: bold;
    }
</style>